import {
    Box,
    Button,
    CircularProgress,
    Typography,
} from '@mui/material';
import FileUpload from 'components/formsUI/FileUpload';
import React, { Dispatch, SetStateAction } from "react";
import { Trans, useTranslation } from 'react-i18next';
import * as attachmentService from "services/attachment-service";

interface IProps {
    request: ApplicationWithDetails | undefined;
    signingInProgress: boolean;
    openDocumentToSign: any;
    hasRead: Dispatch<SetStateAction<boolean>>;
    showMessage: MessageBox;
}

const InProgressModal = (props: IProps) => {
    const { request, signingInProgress, openDocumentToSign, hasRead, showMessage } = props;
    const { t } = useTranslation();

    const handleDownloadManuallyFile = (): void => {
        const file = request?.attachments.filter(a => a.isManualSigned === true)[0];
        attachmentService.getAttachment(file?.id as string).then((res: Blob) => {
            if (res !== undefined) {
                var fileUrl = URL.createObjectURL(res);
                const link = document.createElement("a");
                link.href = fileUrl;
                link.download = `${file?.name}`;
                link.click();
            }
        });
    }

    return (
        <Box>
            {request !== undefined && request.isManuallySigned ? 
                <Box>
                    <Typography variant="body2" gutterBottom>
                        <Trans
                            i18nKey="requestWithDetail.inProgress.infoManual"
                            components={[
                                <Box
                                    component="a"
                                    sx={{ color: "LinkText", textDecoration: "underline", '&:hover': { cursor: 'pointer' } }}
                                    onClick={async () => await handleDownloadManuallyFile()}
                                >
                                </Box>
                            ]}
                        />
                    </Typography>
                    <FileUpload 
                        showMessage={showMessage} 
                        setFilesUploaded={hasRead}
                        isSignedFile={true}
                        textUpload={t('requestWithDetail.inProgress.upload')}
                        title=''
                    />
                </Box> :
                request !== undefined && request.applicationSignedFile && request.applicationSignedFile.length !== 0 ? 
                <Typography variant="body2" gutterBottom>
                    {t("requestWithDetail.inProgress.info")}
                </Typography> :
                <Box>
                    <Typography variant="body2" gutterBottom>
                        {t("requestWithDetail.positive.signText")}
                    </Typography>
                    {signingInProgress === true ? 
                        <CircularProgress /> :
                        <Button onClick={openDocumentToSign} variant="contained">{t("requestWithDetail.positive.signButton")}</Button>
                    }
                </Box>
            }
        </Box>
    );
}

export default InProgressModal;